// 越南语
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "Lịch sử",
    emptyRecords: "Chưa có lịch sử Vòng quay trái cây",
    guessResult: "Kết quả dự đoán",
    myGuesses: "Dự đoán của tôi",
    guessFailed: "Dự đoán sai",
    winningPlayers: "Người chơi thắng",
    noGuesses: "Bạn chưa dự đoán trong vòng này",
    noWinners: "Không có người chơi thắng trong vòng này",
    rulesTitle: "Hướng dẫn chơi",
    rulesDescription: "Mỗi vòng có 50 giây để dự đoán loại trái cây sẽ xuất hiện. Dự đoán đúng sẽ nhận được phần thưởng sương tương ứng.",
    guessingTitle: "Cách dự đoán",
    guessingDescription: "Trong thời gian dự đoán, chọn số lượng sương muốn đặt cược, rồi chạm vào khu vực đặt cược của trái cây trên màn hình.",
    rewardsTitle: "Phần thưởng",
    rewardsDescription: "Các loại trái cây khác nhau có phần thưởng sương khác nhau.",
    fruit: "Trái cây",
    multiplier: "Hệ số thưởng",
    apple: "Táo",
    watermelon: "Dưa hấu",
    orange: "Cam",
    banana: "Chuối",
    grape: "Nho",
  },
  setPresident: {
    intro: "Bạn có thể bổ nhiệm chủ nhiệm để hỗ trợ quản lý câu lạc bộ",
    selfIntro: "Bạn là chủ nhiệm câu lạc bộ",
    president: "Chủ nhiệm",
    empty: "Chưa bổ nhiệm chủ nhiệm",
    appoint: "Bổ nhiệm",
    privileges: "Quyền của chủ nhiệm",
    privilegesIntro: "Chủ nhiệm có các quyền sau",
    title: "Bổ nhiệm chủ nhiệm",
    selectMember: "Chọn thành viên bạn muốn bổ nhiệm làm chủ nhiệm",
    member: "Thành viên",
    attendance: "Có mặt {days} ngày",
    weekContribution: "Đóng góp danh vọng (tuần):",
    monthContribution: "(tháng):",
    confirmAppoint: "Bổ nhiệm thành viên này làm chủ nhiệm?",
    confirm: "Xác nhận",
    remove: "Miễn nhiệm",
    cancel: "Hủy",
    removeTitle: "Miễn nhiệm chủ nhiệm",
    confirmRemove: "Xác nhận miễn nhiệm chủ nhiệm {name}?",
    unnamed: "Chưa đặt tên",
    pkTitle: "Phòng PK",
    pkDesc: "Chủ nhiệm có thể mở, đóng và quản lý phòng PK của câu lạc bộ",
    infoTitle: "Thông tin câu lạc bộ",
    infoDesc: "Chủ nhiệm và lãnh chúa có thể chỉnh sửa ảnh bìa, tên, tuyên ngôn và các thông tin khác của câu lạc bộ",
    membersTitle: "Quản lý thành viên",
    membersDesc: "Chủ nhiệm và lãnh chúa đều có thể xóa thành viên và khách khỏi câu lạc bộ",
    rewardsTitle: "Phần thưởng câu lạc bộ",
    rewardsDesc: "Chủ nhiệm có thể nhận phần thưởng của câu lạc bộ. Không thể nhận nếu chưa bổ nhiệm chủ nhiệm",
    moderationTitle: "Quản lý phòng livestream",
    moderationDesc: "Chủ nhiệm tự động có quyền quản lý phòng livestream của lãnh chúa",
    newPlayersTitle: "Kênh người chơi mới",
    newPlayersDesc: "Chủ nhiệm và lãnh chúa có thể xem kênh người chơi mới",
    loadMembersFailed: "Không thể tải danh sách thành viên",
    appointFailed: "Bổ nhiệm chủ nhiệm thất bại",
    appointSuccess: "Bổ nhiệm thành công",
    removeFailed: "Miễn nhiệm thất bại",
    removeSuccess: "Miễn nhiệm thành công",
    customerService: "Chăm sóc khách hàng",
    loadClubFailed: "Không thể tải thông tin câu lạc bộ",
  },
  /* 總榜單 */
  allRank: {
    lang1: "phát thanh viên",
    lang2: "Giàu có",
    lang3: "PK",
    lang4: "trận chiến câu lạc bộ",
    lang5: "người Trung Quốc",
    lang6: "Tiếng Anh",
    lang7: "tiếng Thái",
    lang8: "tiếng Nhật",
    lang9: "tiếng Indonesia",
    lang10: "Tiếng Việt",
    lang11: "Giờ",
    lang12: "Hằng ngày",
    lang13: "hàng tuần",
    lang14: "tuần này",
    lang15: "Tuần trước",
    lang16: "hàng tháng",
    lang17: "Danh sách xếp hạng",
    lang18: "Phần thưởng",
    lang19: "tỷ lệ kết nối",
    lang20: "điểm câu lạc bộ",
    lang21: "Thành viên",
    lang22: "Không có dữ liệu",
    lang23: "chưa được liệt kê",
    lang24: "Câu lạc bộ fan hâm mộ",
    lang25: "Ngày",
    lang26: "Không thể theo dõi chính mình",
    lang27: "Theo dõi thành công",
    lang28: "Bỏ theo dõi thành công",
    lang29: "Chờ",
    lang30: "Hôm qua",
    lang31: "Tháng trước",
    lang32: "Không có trong danh sách",
    lang33: "Xếp hạng của tôi",
    lang34: "Emissary",
    lang35: "Danh sách phần thưởng hàng tháng",
    lang36: "Danh sách đệ tử hàng tháng",
    lang37: "Club",
    lang38: "Nhóm người hâm mộ",
    lang39: "Không có khẩu hiệu",
    lang40: "Thành viên",
    lang41: "Thành viên",
    lang42: "Danh tiếng trong tuần",
    lang43: "Tổng danh tiếng",
    lang44: "Xếp hạng Câu lạc bộ",
    lang45: "Chia sẻ",
    lang46: "Ra mắt",
    lang47: "gửi lời mời tham gia Câu lạc bộ",
    lang48: "Ra mắt FIREFLY để có nhiều người phát sóng trực tiếp vui vẻ hơn",
    lang49: "Xếp hạng phần thưởng hàng tuần",
    lang50: "Xếp hạng số tiền hàng tuần",
    lang51: "Danh tiếng",
    lang52: "Thưởng",
  },

  /* 俱乐部 */
  club: {
    lang1: "phát thanh viên",
    lang2: "Giàu có",
    lang3: "PK",
    lang4: "trận chiến câu lạc bộ",
    lang5: "người Trung Quốc",
    lang6: "Tiếng Anh",
    lang7: "tiếng Thái",
    lang8: "tiếng Nhật",
    lang9: "tiếng Indonesia",
    lang10: "Tiếng Việt",
    lang11: "Giờ",
    lang12: "Hằng ngày",
    lang13: "hàng tuần",
    lang14: "tuần này",
    lang15: "Tuần trước",
    lang16: "hàng tháng",
    lang17: "Danh sách xếp hạng",
    lang18: "Phần thưởng",
    lang19: "tỷ lệ kết nối",
    lang20: "điểm câu lạc bộ",
    lang21: "Thành viên",
    lang22: "Không có dữ liệu",
    lang23: "chưa được liệt kê",
    lang24: "Câu lạc bộ fan hâm mộ",
    lang25: "Ngày",
    lang26: "Không thể theo dõi chính mình",
    lang27: "Theo dõi thành công",
    lang28: "Bỏ theo dõi thành công",
    lang29: "Chờ",
    lang30: "Biểu đồ đóng góp điểm",
    lang31: "Lớp",
    lang37: "Club",
    lang38: "Nhóm người hâm mộ",
    lang39: "Không có khẩu hiệu",
    lang40: "Thành viên",
    lang41: "Thành viên",
    lang42: "Danh tiếng trong tuần",
    lang43: "Tổng danh tiếng",
    lang44: "Xếp hạng Câu lạc bộ",
    lang45: "Chia sẻ",
    lang46: "Ra mắt",
    lang47: "gửi lời mời tham gia Câu lạc bộ",
    lang48: "Mở FIREFLY và tham gia câu lạc bộ để cùng vui chơi nhé~",
    lang49: "Nhóm người hâm mộ",
    lang50: "Lãnh chúa: ",
    lang51: "Chủ tịch: ",
    // Nhãn vai trò ở dòng "Hạng của tôi" trong trang bảng xếp hạng câu lạc bộ.
    lang52: "Lãnh chúa",
    lang53: "Chủ tịch",
    lang54: "Thành viên",

    lang55: "Chưa có câu lạc bộ trực thuộc",

    lang56: "Chưa thiết lập câu lạc bộ trực thuộc",
  },

  /* 榜单 */
  rank: {
    lang1: "phát thanh viên",
    lang2: "Giàu có",
    lang3: "PK",
    lang4: "trận chiến câu lạc bộ",
    lang5: "người Trung Quốc",
    lang6: "Tiếng Anh",
    lang7: "tiếng Thái",
    lang8: "tiếng Nhật",
    lang9: "tiếng Indonesia",
    lang10: "Tiếng Việt",
    lang11: "Giờ",
    lang12: "Hằng ngày",
    lang13: "hàng tuần",
    lang14: "tuần này",
    lang15: "Tuần trước",
    lang16: "hàng tháng",
    lang17: "Danh sách xếp hạng",
    lang18: "Phần thưởng",
    lang19: "tỷ lệ kết nối",
    lang20: "điểm câu lạc bộ",
    lang21: "Thành viên",
    lang22: "Không có dữ liệu",
    lang23: "chưa được liệt kê",
    lang24: "Câu lạc bộ fan hâm mộ",
    lang25: "Ngày",
    lang26: "Không thể theo dõi chính mình",
    lang27: "Theo dõi thành công",
    lang28: "Bỏ theo dõi thành công",
    lang29: "Chờ",
    lang30: "Hôm qua",
    lang31: "Tháng trước",
    lang32: "Không có trong danh sách",
    lang33: "Xếp hạng của tôi",
    newDraw96: "Cuộc gọi riêng",
  },

  /* TOP hub */
  topRankList: {
    title: "FIREFLY TOP Center",
    playerCoreTitle: "Player Core TOP",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "Broadcaster Core TOP",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "Player Rankings",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "Broadcaster Rankings",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY Rich Ranking",
    anchorBoard: "FIREFLY Broadcaster Ranking",
    clubBoard: "Club Ranking",
    emissaryBoard: "Emissary Ranking",
    mountBoard: "Car Ranking",
    ludoBoard: "LUDO PK Ranking",
    gardenBoard: "Firefly Garden Ranking",
    firstLoveBoard: "FirstLove Ranking",
    newStarBoard: "New Star Ranking",
    pkBoard: "PK Ranking",
    privateCreditBoard: "Private Credit Ranking",
  },

  /* 珍愛團 */
  treasureGroup: {
    lang1: "phát thanh viên",
    lang2: "Giàu có",
    lang3: "PK",
    lang4: "trận chiến câu lạc bộ",
    lang5: "người Trung Quốc",
    lang6: "Tiếng Anh",
    lang7: "tiếng Thái",
    lang8: "tiếng Nhật",
    lang9: "tiếng Indonesia",
    lang10: "Tiếng Việt",
    lang11: "Giờ",
    lang12: "Hằng ngày",
    lang13: "hàng tuần",
    lang14: "tuần này",
    lang15: "Tuần trước",
    lang16: "hàng tháng",
    lang17: "Danh sách xếp hạng",
    lang18: "Phần thưởng",
    lang19: "tỷ lệ kết nối",
    lang20: "điểm câu lạc bộ",
    lang21: "Thành viên",
    lang22: "Không có dữ liệu",
    lang23: "chưa được liệt kê",
    lang24: "Câu lạc bộ fan hâm mộ",
    lang25: "Ngày",
    lang26: "Không thể theo dõi chính mình",
    lang27: "Theo dõi thành công",
    lang28: "Bỏ theo dõi thành công",
    lang29: "Chờ",
    lang30: "Biểu đồ đóng góp điểm",
    lang31: "Lớp",
    lang37: "Club",
    lang38: "Nhóm người hâm mộ",
    lang39: "Không có khẩu hiệu",
    lang40: "Thành viên",
    lang41: "Thành viên",
    lang42: "Danh tiếng trong tuần",
    lang43: "Tổng danh tiếng",
    lang44: "Xếp hạng Câu lạc bộ",
    lang45: "Chia sẻ",
    lang46: "Ra mắt",
    lang47: "gửi lời mời tham gia Câu lạc bộ",
    lang48: "Ra mắt FIREFLY để có nhiều người phát sóng trực tiếp vui vẻ hơn",
  },

  /* 珍愛值記錄 */
  treasureRecord: {
    recordTitle2: "Trân trọng kỷ lục giá trị",
    income10: "Tháng này",
    income11: "Tháng trước",
    news7: "Các vấn đề",
    news13: "Fan Value",
    cashreal6: "Hủy",
    box1: "Chưa có hồ sơ nào",
  },

  /* 俱乐部说明页 */
  groupIntruduction: {
    lang1: "Giới thiệu câu lạc bộ",
    lang2:
      "Câu lạc bộ là một nhóm gồm những người hâm mộ cốt cán của người dẫn chương trình. Khi tham gia câu lạc bộ, bạn có thể cùng nhau tham gia các sự kiện và cuộc thi thú vị, đồng thời trở thành bạn bè với các thành viên trong cùng câu lạc bộ. Số lượng nhóm người hâm mộ và danh tiếng là những điểm cạnh tranh chính của câu lạc bộ, đồng thời cũng tượng trưng cho sức ảnh hưởng và sự nổi tiếng của người dẫn chương trình sáng lập.",
    lang3: "Giới thiệu về các thuộc tính chuyên biệt của câu lạc bộ",
    lang4: "Người sáng tạo C.by:",
    lang5:
      "Người sáng lập câu lạc bộ, thường là người dẫn chương trình. Người dẫn chương trình sẽ mở câu lạc bộ sau khi số lượng người mà anh ta theo dõi đạt đến một con số nhất định.",
    lang6: "P.by Chủ tịch:",
    lang7:
      "Người quản lý câu lạc bộ sẽ có hiệu lực sau khi được người chủ trì chỉ định. Chủ tịch câu lạc bộ cũng trở thành người quản lý phòng phát sóng trực tiếp của người sáng tạo C.by.",
    lang8: "Thành viên:",
    lang9:
      'Thành viên của câu lạc bộ. Cách tham gia là gửi quà tặng "Cherish You" hoặc "Cherish Together" trong quá trình phát sóng trực tiếp. Không giới hạn số lượng thành viên trong bất kỳ câu lạc bộ nào.',
    lang10: "Quà tặng độc quyền:",
    lang11:
      "Các cuộc thi câu lạc bộ với những món quà chuyên biệt. Gửi quà câu lạc bộ để kiếm điểm câu lạc bộ.",
    lang12: "Điểm câu lạc bộ:",
    lang13:
      "1. Gửi quà tặng độc quyền của câu lạc bộ trong phòng phát sóng trực tiếp của người sáng lập câu lạc bộ để tích lũy điểm câu lạc bộ. 2. Hoàn thành nhiệm vụ câu lạc bộ hàng ngày trong phòng phát sóng trực tiếp của người sáng lập câu lạc bộ để tích lũy điểm câu lạc bộ.",
    lang14: "Danh tiếng:",
    lang15:
      "Tổng điểm câu lạc bộ của tất cả các thành viên trong cùng một câu lạc bộ là danh tiếng của câu lạc bộ. Tổng điểm câu lạc bộ tăng lên của tất cả các thành viên trong câu lạc bộ mỗi tuần là danh tiếng hàng tuần của câu lạc bộ.",
    lang16: "Cấp độ thành viên",
    lang17:
      "1. Quá trình tích lũy điểm câu lạc bộ là quá trình hoàn tất nâng cấp. Vui lòng tham khảo biểu tượng ở trên để biết chi tiết. 2. Gửi quà tặng câu lạc bộ. 1 viên ngọc = 1 điểm câu lạc bộ (không ảnh hưởng đến các thuộc tính khác của quà tặng). 3. Điểm câu lạc bộ sẽ không còn tăng nữa sau khi đạt đến giới hạn trên trong ngày.",
    lang18: "Hạ cấp thành viên",
    lang19:
      "1. Trong câu lạc bộ, khi thành viên không đóng góp bất kỳ điểm câu lạc bộ nào trong 3 ngày liên tiếp, điểm câu lạc bộ sẽ bắt đầu giảm từ ngày thứ 4. 2. Việc điểm câu lạc bộ liên tục giảm sẽ khiến thành viên bị hạ cấp. Vui lòng tham khảo cấp độ của thành viên để biết chi tiết. 3. Nếu điểm câu lạc bộ giảm xuống 0, thành viên sẽ tự động rời khỏi câu lạc bộ.",
    lang20: "Quyền lợi của thành viên",
    lang21: "khác",
    lang22:
      "Nếu câu lạc bộ có tài khoản giả, gian lận hoặc có tên hoặc ảnh bìa vi phạm luật pháp và quy định của địa phương, nền tảng FIREFLY có quyền sửa đổi hoặc xóa câu lạc bộ.",
    lang23: "Cấp độ câu lạc bộ",
    lang24: "Điểm cần thiết để nâng cấp",
    lang25: "Daily bonus",
    lang26: "Giới hạn trên của điểm câu lạc bộ",
    lang27: "Suy giảm",
    lang28: "Đặc quyền",
    lang29: "Mô tả",
    lang30: "Bảng tên câu lạc bộ",
    lang31:
      "Xác định cấp độ đặc biệt trong phòng phát sóng trực tiếp của người sáng tạo C.by",
    lang33:
      "Quà tặng độc quyền trong phòng phát sóng trực tiếp của người sáng tạo C.by",
    lang34: "Hộp trò chuyện độc quyền",
    lang35:
      "Hộp trò chuyện độc quyền trong phòng phát sóng trực tiếp của người sáng tạo C.by",
    lang36: "Hộp kho báu của câu lạc bộ",
    lang37:
      "Bạn có thể giành được đặc quyền của hộp kho báu câu lạc bộ trong phòng phát sóng trực tiếp của người sáng tạo ra C.by",
    lang38: "Daily bonus",
    lang39:
      "Bạn có thể hoàn thành nhiệm vụ hàng ngày trong phòng phát sóng trực tiếp của người sáng tạo C.by để nhận gói quà tặng.",
    lang40: "Trò chuyện thành viên",
    lang41:
      "Trò chuyện với tất cả thành viên của câu lạc bộ bằng tin nhắn riêng mà không có bất kỳ hạn chế thân mật nào",
    lang42: "Làm mới",
    lang43: "Dịch vụ khách hàng",
    lang44: "Đóng trang",
    lang45: "Câu lạc bộ",
    lang46: "Club",
    lang47:
      "Câu lạc bộ là cộng đồng riêng do người chơi và lãnh chúa cùng xây dựng. Hãy tham gia và đóng góp danh tiếng để câu lạc bộ tranh tài giành vinh dự và nhận phần thưởng bảng xếp hạng độc quyền!",
    lang48: "Câu lạc bộ trực thuộc",
    lang49:
      "Mỗi người chơi có thể chọn tối đa một câu lạc bộ trực thuộc. Sau khi chọn, vai trò của bạn trong câu lạc bộ đó sẽ đổi thành 「Thành viên」. Danh tiếng từ vinh dự (như vô địch bảng xếp hạng, vô địch cuộc thi tài năng ban đêm) và chiến thắng trò chơi trong phòng PK sẽ tự động được đóng góp cho câu lạc bộ trực thuộc.",
    lang50: "Tham gia/rời câu lạc bộ",
    lang51:
      "Người chơi tham gia câu lạc bộ của lãnh chúa bằng cách tặng lãnh chúa quà 「Chuông Trần Tâm」. Sau khi tham gia bằng quà tặng, vai trò của bạn là 「Khách」. Người chơi có thể tự do rời câu lạc bộ.",
    lang52: "Danh tiếng",
    lang53:
      "Danh tiếng là yếu tố cốt lõi trong cạnh tranh giữa các câu lạc bộ. Tất cả mọi người trong câu lạc bộ đóng góp danh tiếng bằng cách hoàn thành nhiệm vụ câu lạc bộ, tranh chức vô địch sự kiện xếp hạng, tham gia và chiến thắng trò chơi.",
    lang54: "Phần thưởng câu lạc bộ",
    lang55:
      "Phần thưởng câu lạc bộ giành được qua thi đấu sẽ được gửi cho chủ tịch. Câu lạc bộ chưa bổ nhiệm chủ tịch không thể nhận phần thưởng câu lạc bộ.",
    lang56: "Xếp hạng câu lạc bộ",
    ranked: "Đã xếp hạng",
    lang57:
      "Câu lạc bộ đáp ứng các điều kiện sau có thể tham gia bảng xếp hạng FIREFLY Club:",
    lang58: "Đổi tên câu lạc bộ",
    lang59: "Đổi ảnh bìa câu lạc bộ",
    lang60: "Bổ nhiệm chủ tịch",
    lang61:
      "Câu lạc bộ chưa đáp ứng các điều kiện trên vẫn có thể tiếp nhận người chơi và tích lũy danh tiếng, nhưng không thể tham gia bảng xếp hạng.",
    lang62: "Vai trò trong câu lạc bộ",
    lang63: "Club Role",
    lang64: "Lãnh chúa",
    lang65:
      "Lãnh chúa là người sáng lập và gắn bó chặt chẽ với câu lạc bộ. Lãnh chúa có quyền quản lý, chỉnh sửa câu lạc bộ và bổ nhiệm chủ tịch.",
    lang66: "Chủ tịch",
    lang67:
      "Được lãnh chúa bổ nhiệm, có quyền quản lý và chỉnh sửa câu lạc bộ. Có thể mở phòng PK của câu lạc bộ.",
    lang68:
      "<span class='highlight-text'>Phần thưởng câu lạc bộ: </span>Tất cả phần thưởng dành cho câu lạc bộ đều được gửi cho chủ tịch. Câu lạc bộ chưa bổ nhiệm chủ tịch không thể nhận phần thưởng câu lạc bộ.",
    lang69: "Thành viên",
    lang70:
      "Người chơi đã tham gia và chọn câu lạc bộ này làm 「câu lạc bộ trực thuộc」. Phần thưởng danh tiếng từ vinh dự và trò chơi sẽ tự động được đóng góp cho câu lạc bộ trực thuộc.",
    lang71: "Khách",
    lang72:
      "Người chơi đã tham gia câu lạc bộ nhưng chưa chọn làm 「câu lạc bộ trực thuộc」.",
    lang73: "Câu lạc bộ Vương giả",
    lang74:
      "Câu lạc bộ vô địch bảng xếp hạng tuần của FIREFLY sẽ trở thành 「Câu lạc bộ Vương giả」 trong tuần tiếp theo. Trong thời gian này, khách không thể chọn Câu lạc bộ Vương giả làm câu lạc bộ trực thuộc. Tên câu lạc bộ sẽ hiển thị cho các thành viên ở tất cả phòng phát trực tiếp.",
    lang75: "Thêm",
  },

  /* 极速狂飙 */
  kingOfSpeed: {
    lang1: "Luật chơi",
    lang2: "Mô tả Trò chơi",
    lang3:
      "1. Lăn xúc xắc: Mỗi lần nhấp vào Lăn xúc xắc tốn 1000 DEW. Việc tung xúc xắc sẽ tăng điểm thưởng cho xe của đội.",
    lang4:
      "2. Xác suất Xúc xắc: Xác suất xuất hiện của mỗi hiệu ứng trong sáu hiệu ứng là như nhau, nhưng hiệu ứng thưởng trên mỗi mặt là khác nhau.",
    lang5:
      "3. Kết quả trò chơi: Khi hết thời gian PK, đội nào có khoảng cách xa hơn sẽ thắng, đội nào có khoảng cách xa hơn sẽ thua. Nếu cả hai đội có cùng khoảng cách, kết quả hòa.",
    lang6: "Mô tả xe",
    lang7:
      "1. Yêu cầu về Xe: Nếu người phát sóng không có xe khi bắt đầu trò chơi, xe của đội hiện tại sẽ không thể được thành lập.",
    lang8: "Mô tả cấp độ Qi",
    lang9:
      "1. Thăng cấp: Người chơi tương tác với nhau để tăng độ nổi tiếng của người dẫn chương trình. Độ nổi tiếng được sử dụng để tăng cấp Khí của đội. Cấp Khí càng cao, hiệu ứng thưởng xúc xắc càng mạnh.",
    lang10: "2. Yêu cầu về Cấp độ Khí:",
    lang11: "Cấp độ Xúc xắc",
    lang12: "Phổ biến",
    lang13: "Mô tả về Nhóm DEW",
    lang14:
      "1. DEWs Pool: Số DEW từ xúc xắc do cả hai người chơi tung ra sẽ được tích lũy vào DEWs Pool. Kết thúc trò chơi, đội chiến thắng sẽ nhận được toàn bộ số DEW trong quỹ làm phần thưởng. Trong trường hợp hòa, người chơi của cả hai đội sẽ nhận được phần thưởng từ Quỹ DEW.",
    lang15:
      "2. Phân phối phần thưởng: Phần thưởng được phân phối dựa trên tỷ lệ phần trăm DEW của mỗi người chơi trên số lần tung xúc xắc của đội chiến thắng. Những người chơi không tung xúc xắc để tham gia trò chơi sẽ không được tham gia vào việc phân phối phần thưởng của Quỹ Dew.",
    lang16:
      "3. Phí dịch vụ: Người chơi nhận phần thưởng từ DEWs Pool. Nền tảng sẽ tính phí dịch vụ 4%.",
    lang17: "Lưu ý phát triển trò chơi",
    lang18:
      "1. Người chơi có thể tham gia Vua Tốc Độ thông qua PK trong trò chơi từ 12:00 trưa ngày 23 tháng 10 năm 2025 đến 00:00 sáng ngày 17 tháng 12 năm 2025.",
    lang19: "Các biện pháp phòng ngừa",
    lang20: "1. Tất cả thời gian trong sự kiện được tính theo giờ máy chủ.",
    lang21:
      "2. Để đảm bảo tính công bằng của trò chơi, nền tảng có quyền điều chỉnh hoặc tạm dừng bất kỳ sự bất thường nào trong trò chơi do các yếu tố bất khả kháng, chẳng hạn như sự cố mạng, gian lận hoặc các hành vi trái phép khác.",
    lang22:
      "3. Trò chơi này chỉ nhằm mục đích giải trí. Nghiêm cấm giao dịch ngoại tuyến giữa người chơi hoặc phát thanh viên. Cảnh giác với các trò lừa đảo hoặc hành vi trục lợi bất hợp pháp.",
    lang23:
      "4. Nền tảng không chịu trách nhiệm cho bất kỳ tổn thất nào trong trò chơi do sự cố mạng cá nhân hoặc thiết bị.",
    lang24: "5. Nền tảng giữ quyền quyết định cuối cùng về kết quả trò chơi.",
    lang25: "Kỷ lục PK",
    lang26: "Thời gian PK",
    lang27: "Lăn xúc xắc",
    lang28: "Đội PK",
    lang29: "Khoảng cách",
    lang30: "Kết quả",
    lang31: "Đang tải...",
    lang32: "Không còn hồ sơ nào nữa",
    lang33: "Không có thành tích PK nào trong trò chơi",
    lang34: "Người phát sóng còn lại không có xe.",
    lang35: "Đội Xanh không có xe",
    lang36: "Đội Đỏ không có xe.",
    lang37: "Giới hạn tốc độ đến",
    lang38: "Tốc độ",
    lang39: "Người phát sóng phải có xe để tham gia trò chơi.",
    lang40: "Khởi hành",
    lang41: "Tips",
    lang42: "Hiện tại không sở hữu xe nên không thể tham gia trò chơi PK",
    lang43: "Đi đến",
    lang44: "Nhóm DEW",
    lang45: "Đội của chúng tôi",
    lang46: "Đối phương",
    lang47: "Ném",
    lang48: "Lượt của tôi:",
    lang49: "Thông tin phần thưởng",
    lang50: "1. Quỹ DEW:",
    lang51:
      "Số DEW từ xúc xắc do cả hai người chơi tung ra sẽ được thêm vào Nhóm DEW. Khi kết thúc trò chơi, đội chiến thắng sẽ nhận được tất cả số DEW trong Nhóm DEW làm phần thưởng. Trong trường hợp hòa, cả hai người chơi",
    lang52: "2. Phân phối phần thưởng:",
    lang53:
      "Phần thưởng được phân phối dựa trên tỷ lệ phần trăm DEW của mỗi người chơi trên số lần tung xúc xắc của đội chiến thắng. Người chơi không tung xúc xắc để tham gia trò chơi sẽ không được tham gia phân phối phần thưởng của DEWs Pool.",
    lang54: "3. Phí dịch vụ:",
    lang55:
      "Người chơi nhận phần thưởng từ Quỹ DEW, và nền tảng sẽ tính phí dịch vụ 4%.",
    lang56: "OK",
    lang57: "Tăng tốc",
    lang58: "Khiên",
    lang59: "Tấn công",
    lang60: "Đội Đỏ",
    lang61: "Đội Xanh",
    lang62: "Chi tiết về Xe đua",
    lang63: "Kích hoạt",
    lang64: "Chưa kích hoạt",
    lang65: "giây",
    lang66: "Tốc độ x2, liên tục",
    lang67: "Đang bảo vệ",
    lang68: "Không được bảo vệ",
    lang69:
      "Khiên chắn cung cấp khả năng kháng cự các hiệu ứng tiêu cực một lần.",
    lang70: "(Cản trở, Giới hạn tốc độ)",
    lang71: "Tiếp tục",
    lang72: "Kích hoạt",
    lang73: "Chưa kích hoạt",
    lang74: "Khi Giá trị Sạc đầy, tốc độ xe tăng gấp 3 lần và thời gian là",
    lang75: "Thời gian Tăng Tốc",
    lang76: "Tăng tốc",
    lang77: "Chế độ Turbo:",
    lang78: "Thời gian hiệu lực của Khiên",
    lang79: "Cản trở",
    lang80: "Chế độ Can thiệp:",
    lang81: "Giới hạn tốc độ",
    lang82: "Lượng xe tăng",
    lang83:
      "Giá trị Tấn công: Khi Giá trị Tấn công đạt 100%, Chế độ Tấn công được kích hoạt. Tốc độ Tấn công là x3 và thời gian là",
    lang84: "Thoát sau khi hết thời gian.",
    lang85: "Chế độ Sạc",
    lang86: "Đặt lại phí",
    lang87: "Xe được tăng tốc.",
    lang88: "Liên tục",
    lang89: "Tốc độ sẽ được phục hồi sau khi hết thời gian.",
    lang90: "Đua xe đạt được",
    lang91: "Phần thưởng",
    lang92: "Tốc độ",
    lang93: "Liên tục",
    lang94: "Kháng cự một lần",
    lang95: "Hiệu ứng tiêu cực",
    lang96:
      "Khi nhiều điểm thưởng lá chắn được trao, các điểm cộng lá chắn sẽ được cộng dồn. Sau khi hết thời gian hoặc hiệu ứng miễn nhiễm được áp dụng, điểm cộng lá chắn sẽ giảm đi 1.",
    lang97: "Sử dụng hiệu ứng gây nhiễu, nhắm vào đối thủ.",
    lang98: "Nhiễu",
    lang99: "Sau khi có hiệu lực, tốc độ bình thường của xe sẽ bị giảm.",
    lang100:
      "Sử dụng hiệu ứng Giới hạn Tốc độ để ra hiệu giảm tốc cho đối thủ, làm chậm xe của họ.",
    lang101: "Cản trở",
    lang102: "Giới hạn tốc độ",
    lang103: "Lăn xúc xắc",
    lang104: "Lăn xúc xắc để nhận phần thưởng.",
    lang105: "Tăng tốc! Cùng nhau chạy nước rút!",
    lang106: "Khẩu hiệu đã được sao chép. Vui lòng dán vào ô nhập và gửi!",
    lang107: "Sao chép không thành công",
    lang108: "Tham gia trò chơi đua xe",
    lang110: "Người phát sóng sở hữu một chiếc xe.",
    lang111: "Đã đạt được",
    lang112: "Chưa đạt được",
    lang113: "Tham gia Đội PK",
    lang115: "Nhấp để gửi xe",
    lang116: "Nhấp để gửi khẩu hiệu của đội",
    lang117: "Trò chơi hiện tại chưa diễn ra, nên không thể tung xúc xắc.",
    lang118: "Người phát sóng không được phép tung xúc xắc.",
    lang119: "Speed ​​Rush, người chiến thắng sẽ được tất cả!",
    lang120: "Trò chơi chưa bắt đầu",
    lang121: "[Vua Tốc Độ] chưa được bật và không thể chơi.",
    lang122: "Xe đua nhận được hiệu ứng Tường Lũy",
    lang123: "Xe không người lái",
    lang124: "Lãnh đạo",
    lang125: "Lỗi theo",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "Trợ lý Trực tiếp",
    lang2:
      "Người chơi được liên kết làm Trợ lý Trực tiếp, người chơi sẽ nhận được phần FIRE nhận được của bạn.",
    lang3: "Đã liên kết Trợ lý Trực tiếp",
    lang4: "Nhập ID để xác nhận người chơi được liên kết",
    lang5: "Nhập ID Người chơi Bạn Muốn Liên kết",
    lang6: "Tiếp theo",
    lang7: "Tỷ lệ chia sẻ FIRE",
    lang8: "Hướng dẫn Liên kết",
    lang9:
      "Sau khi liên kết Trợ lý Trực tiếp, Trợ lý Trực tiếp sẽ nhận được một phần FIRE bạn thu thập được. Số FIRE bạn thu thập được thông qua quà tặng sẽ được gửi đến Trợ lý Trực tiếp theo tỷ lệ chia sẻ FIRE bạn đã thiết lập.",
    lang10: "Chắc chắn",
    lang11: "Liên kết Trợ lý Trực tiếp",
    lang12: "Xác nhận Liên kết?",
    lang13: "Trợ lý Trực tiếp của bạn",
    lang14: "Hủy",
    lang15: "Liên kết thành công",
    lang16: "Liên kết không thành công",
    lang17: "Hủy liên kết thành công",
    lang18: "Hủy liên kết không thành công",
    lang19:
      "Người chơi được liên kết làm Trợ lý Trực tiếp, người chơi sẽ nhận được phần FIRE nhận được của bạn.",
    lang20: "Trợ lý Trực tiếp của Tôi",
    lang21: "Hủy Liên kết",
    lang22: "Đang chờ xác nhận",
    lang23: "Hủy Liên kết Trợ lý Trực tiếp",
    lang24:
      "Việc hủy liên kết khỏi Trợ lý Trực tiếp cần được xác nhận từ phía đối diện. Hủy liên kết?",
    lang25: "Trợ lý Trực tiếp của bạn?",
    lang26: "Hủy Liên kết bị Từ chối",
    lang27: "Hủy Liên kết Bị Từ chối Thất bại",
    lang28: "Cài đặt Trợ lý Trực tiếp",
    lang29: "FIREs Mới",
    lang30:
      "Người đối diện đã hủy liên kết trạng thái Trợ lý Trực tiếp của bạn; cần có xác nhận của bạn.",
    lang31: "Yêu cầu Hủy Liên kết",
    lang32:
      "Điều ngược lại đã được áp dụng để hủy liên kết tài khoản Trợ lý Trực tiếp của bạn. Vui lòng xác nhận.",
    lang33: "Từ chối",
    lang34:
      "Danh sách người phát trực tiếp đã liên kết tôi với tư cách Trợ lý Trực tiếp",
    lang35: "Chưa có người phát trực tiếp nào được liên kết",
    lang36: "Hủy Liên kết Trợ lý Trực tiếp",
    lang37: "Hủy liên kết?",
    lang38: "Mối quan hệ Trợ lý Trực tiếp của bạn là gì?",
    lang39: "Người dùng đã bị cấm.",
    lang40: "Không tìm thấy ID bạn đã nhập.",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang2: "Trạng thái Trực tiếp",
    lang3: "Lịch sử",
    lang4: "Bạn đã bỏ lỡ lượt tham gia hôm nay",
    lang5: "Không thể hủy bỏ quyền tham gia hôm nay",
    lang6: "Thiếu quyền tham gia",
    lang7: "Xếp hạng của tôi",
    lang8: "Thắng",
    lang9: "Hướng dẫn Cuộc thi",
    lang10:
      "Người dẫn chương trình lọt vào Bán kết/Chung kết phải đang trực tuyến và hiện không tham gia trận đấu PK nào khác vào thời gian bắt đầu được chỉ định. Sau đó, hệ thống sẽ tự động bắt đầu trận đấu PK giữa hai người dẫn chương trình tương ứng.",
    lang11: "Bán kết",
    lang12:
      "Thể thức Best-of-5, người dẫn chương trình chiến thắng sẽ vào Chung kết",
    lang13: "Vòng Thử giọng số 1 đấu với Vòng Thử giọng số 4",
    lang14: "Thử giọng số 2 đấu với Thử giọng số 3",
    lang15: "Chung kết",
    lang16:
      "Thể thức Best-of-5, người dẫn chương trình chiến thắng sẽ trở thành Quán quân của 'Glow Night Showdown' trong ngày",
    lang17: "Đội chiến thắng Bán kết",
    lang18:
      "Lưu ý: Nếu bạn đáp ứng các yêu cầu tham gia Vòng Bán kết/Chung kết nhưng không thể tham gia, vui lòng nhấp vào đây trước 20:30 hàng ngày.",
    lang20:
      "Việc vắng mặt trong trận đấu sẽ dẫn đến việc không thể tham gia sự kiện 'Glow Night Showdown' trong 15 ngày tiếp theo.",
    lang22:
      "Việc bỏ cuộc sẽ khiến bạn bị loại khỏi bảng xếp hạng Audition và tư cách tham gia của bạn sẽ được khôi phục vào ngày hôm sau.",
    lang23: "Bạn có muốn bỏ lỡ lượt tham gia hôm nay không?",
    lang24: "Sự kiện Đối đầu Đêm Đom Đóm",
    lang25: "Hủy",
    lang26: "Chắc chắn",
    lang27: "Thắng",
    lang28: "DNF",
    lang29: "Không có thành tích nào trong quá khứ",
    lang30: "Tham gia 'Glow Night Showdown'",
    lang31:
      "Người dẫn chương trình sử dụng FIREFLY V54.0 trở lên để bắt đầu PK (bao gồm 'PK Phổ biến' và 'PK Trò chơi') đều đủ điều kiện tham gia sự kiện Glow Night Showdown.",
    lang32: "Buổi Thử giọng",
    lang33: "Thời gian: Hàng ngày 20:30 - 20:30 ngày hôm sau",
    lang34:
      "Luật: Bảng xếp hạng ghi nhận Giá trị Phổ biến cao nhất mà một đài phát thanh đạt được trong (các) trận PK của họ vào ngày hiện tại, và thứ hạng được tính dựa trên giá trị tối đa này.",
    lang35:
      "Thăng tiến: 4 đài phát thanh đứng đầu trong bảng xếp hạng Vòng Thử giọng tính đến 20:30 hàng ngày sẽ được vào Bán kết.",
    lang36:
      "Bỏ cuộc: Nếu phát thanh viên không thể phát sóng trực tiếp trong thời gian quy định cho Bán kết/Chung kết, họ có thể chọn bỏ cuộc trong thời gian Thử giọng. Phát thanh viên có thứ hạng cao tiếp theo sẽ thay thế.",
    lang37: "Bán kết",
    lang38: "Thời gian: Hàng ngày lúc 21:00 / 21:20",
    lang39:
      "Luật: Hệ thống sẽ tự động bắt đầu trận PK giữa hai đài phát thanh Bán kết vào thời gian được chỉ định. Luật PK là 'PK Phổ biến' theo thể thức Best-of-5. Các đài phát thanh phải duy trì trạng thái trực tiếp trong thời gian này.",
    lang40: "Tiến Lên: Đội chiến thắng sẽ vào Chung kết.",
    lang41:
      "Bỏ cuộc: Phát thanh viên được coi là bỏ cuộc nếu họ không phát trực tiếp khi bắt đầu Vòng Bán kết. Họ sẽ không nhận được phần thưởng xếp hạng và sẽ không đủ điều kiện tham gia 'Glow Night Showdown' trong 15 ngày tiếp theo.",
    lang42: "Được hệ thống bốc thăm ngẫu nhiên sau khi vòng sơ khảo mỗi ngày kết thúc",
    lang43: "Được hệ thống bốc thăm ngẫu nhiên sau khi vòng sơ khảo mỗi ngày kết thúc",
    lang44:
      "Những người thua cuộc ở vòng bán kết sẽ được xếp hạng 3/4 dựa trên Giá trị Phổ biến cao nhất trong ngày.",
    lang45: "Chung kết",
    lang46: "Thời gian: Hàng ngày lúc 22:00",
    lang47:
      "Luật: Hệ thống sẽ tự động bắt đầu trận đấu PK giữa hai người dẫn chương trình Chung kết vào thời gian được chỉ định. Luật PK là 'PK Phổ biến' theo thể thức Best-of-5. Người dẫn chương trình phải duy trì trạng thái trực tuyến trong thời gian này.",
    lang48:
      "Thăng hạng: Người chiến thắng sẽ được trao vương miện Quán quân 'Glow Night Showdown' của ngày.",
    lang49:
      "Thiếu quyền tham gia: Người phát sóng được coi là đã bỏ cuộc nếu họ không trực tiếp vào lúc bắt đầu Vòng chung kết. Họ sẽ không nhận được phần thưởng xếp hạng và sẽ không đủ điều kiện tham gia 'Glow Night Showdown' trong 15 ngày tiếp theo.",
    lang50:
      "Người chiến thắng Chung kết sẽ là Quán quân của ngày, và người thua cuộc sẽ là Số 2 của ngày.",
    lang51: "Phần thưởng",
    lang52: "Phần thưởng DEW của người chơi:",
    lang53: "Bán kết 1: Đội chiến thắng sẽ chia đôi",
    lang54: "Bán kết 2: Đội chiến thắng sẽ chia điểm",
    lang55: "Chung kết: Đội chiến thắng sẽ chia đôi",
    lang56: "Phần thưởng Điểm Phát sóng:",
    lang57:
      "Các đài truyền hình tham gia Vòng Bán kết/Chung kết, sau khi xác định được người chiến thắng, top 4 sẽ nhận được điểm thưởng cho 'Phần thưởng Livestream'. Các đài truyền hình bỏ cuộc sẽ không nhận được điểm thưởng. Vui lòng kiểm tra điểm cụ thể tại đây.",
    lang58: "Phần thưởng phát sóng trực tiếp>",
    lang59: "Các biện pháp phòng ngừa",
    lang60: "1. Sự kiện chỉ giới hạn cho các nữ phát thanh viên",
    lang61:
      "2. Trong thời gian bị hạn chế quyền tham gia hoạt động, tất cả dữ liệu hoạt động sẽ không còn hiệu lực và phải được lấy lại sau khi hạn chế được gỡ bỏ.",
    lang62:
      "3. Người phát trực tiếp phải tích cực tương tác với người chơi. Nền tảng có quyền loại bỏ người phát trực tiếp và tước điểm hoạt động của họ nếu có bất kỳ hành vi nào vi phạm 'Thỏa thuận Người phát trực tiếp' hoặc làm mất cân bằng sự kiện (bao gồm nhưng không giới hạn ở: phát trực tiếp lộ mặt, phát trực tiếp chất lượng thấp, màn hình đen, phát trực tiếp AFK, phát trực tiếp trong khi chơi game, xem TV, thông đồng trong kết quả PvP và chơi thụ động). Người phát trực tiếp vi phạm các quy tắc trên sẽ bị nền tảng áp dụng 'hình phạt thẻ đỏ'.",
    lang63: "4. Nền tảng giữ quyền quyết định cuối cùng cho sự kiện này.",
    lang64: "Trong Vòng Thử giọng",
    lang65: "20:30 - 20:30 ngày hôm sau",
    lang66:
      "Bắt đầu PK để tham gia bảng xếp hạng Audition. Bảng xếp hạng sẽ ghi nhận Giá trị Phổ biến PK cao nhất trong ngày và top 4 sẽ tiến vào Vòng Bán kết.",
    lang67: "Khu vực Thăng hạng",
    lang68: "Không có hồ sơ Thử giọng nào được công bố",
    lang69:
      "Đom Đóm Bạn đã giữ một suất tham dự Vòng Chung kết Glow Night Showdown.",
    lang70:
      "Hàng ngày 21:00-23:00, người chiến thắng PK sẽ nhận được phần thưởng DEW",
    lang71: "Phát thanh viên vào Chung kết chưa được xác định",
    lang72: "Chưa xác định được người dẫn chương trình vòng bán kết",
    lang74: "Buổi Thử giọng SỐ 1",
    lang75: "Buổi Thử giọng SỐ 2",
    lang76: "Buổi Thử giọng SỐ 3",
    lang77: "Buổi Thử giọng SỐ 4",
    lang78: "Lưu ý >",
    lang79: "Phần thưởng cho đội chiến thắng",
    lang80: "Đấu 5 đội",
    lang81: "Đã khóa Xếp hạng",
    lang82: "Chưa có thứ hạng",
    lang83:
      "「FIREFLY」Bạn đã đặt vé vào vòng bán kết chương trình tìm kiếm tài năng đêm huỳnh quang 1.",
    lang84:
      "「FIREFLY」Bạn đã đặt vé vào vòng bán kết chương trình tìm kiếm tài năng đêm huỳnh quang 2.",
    lang85: "Đang tải thêm...",
    lang86: "Cuộn xuống để tải thêm",
    lang87: "Hiện tại không có thêm thông tin nào.",
    lang88: "Thẻ đỏ:",
    lang89:
      "a.Hủy bỏ quyền được nhận phần thưởng cho 'Chương trình Ánh sáng Ban đêm' vào ngày hôm đó.",
    lang90: "b.5 ngày tới không được tham gia sự kiện 'Audisi Malam Fluoresen'",
    lang91: "Phần thưởng",
    lang92:
      "Top 4 streamer trong 'Buổi thử giọng đêm huỳnh quang' hàng ngày sẽ nhận được phần thưởng",
    lang93: "Vô địch",
    lang94: "NO.2",
    lang95: "NO.3/NO.4",
    lang96: "Xếp hạng khác",
    lang97: "Không có phần thưởng",
    lang98: "Nhận",
    lang99: "Chưa nhận được phần thưởng Buổi thử giọng đêm huỳnh quang",
    lang100: "Đã nhận",
    lang101: "Bạn đã nhận phần thưởng Buổi thử giọng đêm huỳnh quang",
    lang102: "Nhận thành công",
    lang103: "Streamer có thể nhận phần thưởng đá quý:",
    lang104: "Vô địch:",
    lang105: "Hạng nhì:",
    lang106: "Hạng ba/tứ:",
    lang107: "Phần Thưởng Chung Kết",
    lang108: "Kết Quả",
    lang109: "Phần Thưởng",
    lang110: "Thắng",
    lang111: "Thua",
    lang112: "Chưa Hoàn Thành",
    lang123: "Không Có Phần Thưởng",
    lang124: "Phần Thưởng Bán Kết",
    lang125: "Phần Thưởng Vòng Sơ Khảo",
    lang126: "Phần Thưởng Chung Kết",
    lang127:
      'Tham gia Chung kết "Vòng Tuyển chọn Ban đêm Huỳnh Quang", có thể nhận phần thưởng sau khi Chung kết kết thúc.',
    lang128: "Phần Thưởng Bán Kết",
    lang129:
      'Tham gia Bán kết "Vòng Tuyển chọn Ban đêm Huỳnh Quang", có thể nhận phần thưởng sau khi Chung kết kết thúc.',
    lang130: "Phần Thưởng Vòng Sơ Khảo",
    lang131:
      'Top 8 trong "Chung kết Tuyển chọn Ban đêm" có thể nhận, phát hàng ngày lúc 21:00.',
    lang132: "Chưa Bắt Đầu",
    lang133: "Đang PK",
    lang134: "Đã Kết Thúc",
    lang135: "Hiện không có phần thưởng nào để nhận",
    lang136: "Bạn đã nhận phần thưởng rồi",
    lang137: "Tham gia PK Tuyển chọn Ban đêm Huỳnh Quang, thắng ",
    lang138: "Nhận",
    lang139: "Đã Nhận",
    lang140: "Nhận Tất Cả",
    lang141: "Phần Thưởng Của Tôi",
    lang142: "Trung bình",
    lang143: "NO.1-NO.4",
    lang144: "Xếp Hạng Sơ Khảo",
    lang145: "NO.5-NO.8",
    lang146: "Không Có Phần Thưởng",
    lang147: "Xếp Hạng Khác",
    lang148: "Không Tham Gia",
    lang149: "Khu Vực Phần Thưởng",
    lang150:
      "Vui lòng cập nhật ứng dụng lên phiên bản V57.0 trở lên để nhận phần thưởng!",
    lang151: "Kết Quả Vòng",
    lang152:
      "Có thể nhận sau khi xếp hạng chung cuộc Night Draft hôm nay được xác định",
    lang153: "Top 4 Vòng Loại",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      "Người chơi mới đăng ký trong vòng 7 ngày và hoàn thành sự kiện nạp tiền 'Gói Quà Nạp Tiền Lần Đầu' sẽ nhận được phần thưởng quà tặng 'FirstLove'. Gửi quà tặng 'FirstLove' sẽ liên kết người chơi phát trực tiếp với FirstLove, và bình luận của họ trên livestream sẽ có thẻ đặc biệt. Mỗi người chơi chỉ có thể liên kết một tài khoản FirstLove.",
    lang3: "Tham gia Gói Quà Nạp Tiền Lần Đầu",
    lang4: "Gửi Quà",
    lang5: "BXH qua dau FirstLove",
    lang6:
      "BXH qua dau FirstLove duoc xep hang theo so luong qua dau FirstLove ma host nhan duoc. Host nhan duoc cang nhieu se xep hang cang cao. Neu nhieu host nhan duoc cung mot so luong FirstLove,",
    lang7: "host dat den so luong do truoc se xep hang cao hon.",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "Phần thưởng hàng ngày",
    lang2: "Ghi nhận Phần thưởng",
    lang3: "【Nhiệm vụ Chào mừng】",
    lang4: "Điểm",
    lang5:
      "Hoàn thành sự kiện 'Chào mừng PK'; bạn có thể nhận tối đa 6000 điểm mỗi ngày.",
    lang6: "Chào mừng PK",
    lang7:
      "Kiếm điểm cho mỗi trận 'Chào mừng PK' (1 giờ) hoàn thành dựa trên kết quả PK.",
    lang8: "Sự kiện",
    lang9: "Đã nhận được",
    lang10: "Nhận",
    lang11: "Đã nhận",
    lang12: "Cách đổi điểm",
    lang13: "Điểm của tôi",
    lang14: "Phần thưởng",
    lang15: "Giai đoạn",
    lang16: "Tổng điểm tích lũy",
    lang19: "Phần thưởng điểm",
    lang20: "Phần thưởng Chào mừng",
    lang21:
      "Sự kiện Chào mừng PK hàng ngày với hỗ trợ lưu lượng truy cập độc quyền.",
    lang25: "Lượt THÍCH",
    lang26: "Không có dữ liệu",
    lang27: "Quy tắc phần thưởng chào mừng",
    lang29:
      "Khi một streamer mới bắt đầu PK, họ chọn 'Chào mừng PK' và bắt đầu ghép trận. Trận Chào mừng PK sẽ cạnh tranh về số lượt THÍCH mà cả hai streamer nhận được.",
    lang30: "Cách nhận LIKES:",
    lang31: "Nhận quà tặng độc quyền dành cho người chơi mới",
    lang32: "Mô tả quà tặng độc quyền:",
    lang33: "Tên quà tặng:",
    lang34: "Cách nhận:",
    lang35:
      "Người chơi mới đăng ký sẽ nhận được quà tặng này miễn phí, có hiệu lực trong 48 giờ. Bạn có thể nhận bằng cách nhấp vào 'Quà tặng người mới' trong phòng phát trực tiếp.",
    lang36: "Thích",
    lang37: "FirstLove",
    lang38:
      "Người chơi mới hoàn thành sự kiện nạp tiền 'Gói quà tặng nạp tiền lần đầu' trong vòng 7 ngày kể từ khi đăng ký sẽ nhận được phần thưởng quà tặng 'Tình yêu đầu tiên'.",
    lang39: "Bạn đã nhận được điểm của ngày hôm nay.",
    lang40: "Không thể nhận điểm nếu không đáp ứng yêu cầu phần thưởng.",
    lang41: "Nhận điểm thưởng Chào mừng thành công",
    lang42: "Hỗ trợ Người dùng Chào mừng",
    lang43:
      "Kích hoạt 'Chào mừng PK' sẽ giúp bạn nhận được hỗ trợ lưu lượng truy cập chào mừng. Người chơi mới đăng ký trong thời gian diễn ra 'Chào mừng PK' sẽ tự động được chuyển đến phòng phát trực tiếp 'Chào mừng PK'.",
    lang44: "Nhận điểm",
    lang45:
      "Hoàn thành 'Phần thưởng Hàng ngày' để kiếm điểm. Tích lũy điểm để đạt cấp độ tương ứng và nhận Phần thưởng Đom đóm.",
    lang46: "Ghi chú",
    lang47: "1. Sự kiện này chỉ dành cho các streamer nữ.",
    lang48:
      "3. Chỉ một tài khoản trên mỗi thiết bị có thể nhận phần thưởng; nhiều tài khoản nhận phần thưởng sẽ bị loại và không được khôi phục.",
    lang49:
      "4. Trong thời gian hạn chế tham gia, tất cả dữ liệu sự kiện đều không hợp lệ và phải được khôi phục lại sau khi hạn chế được dỡ bỏ.",
    lang50:
      "5. Điểm thưởng hàng ngày phải được nhận thủ công. Vui lòng nhận trước 12:00 trưa ngày 3 tháng 12 năm 2025. Nhận muộn sẽ không được cấp lại.",
    lang51:
      "6. Tài khoản đã được liên kết với người mời không được phép tạo tài khoản phụ để phát trực tiếp và nhận điểm. Khi bị phát hiện, tất cả các tài khoản sẽ bị loại và không được khôi phục tư cách tham gia.",
    lang52:
      "7. Tài khoản không có người mời không bị hạn chế tài khoản và có thể đủ điều kiện tham gia, nhưng chỉ một tài khoản có thể tham gia sự kiện phần thưởng.",
    lang53:
      "8. Người phát trực tiếp phải tích cực tương tác với người chơi. Đối với bất kỳ hành vi nào vi phạm 'Thỏa thuận Phát trực tiếp của Người phát trực tiếp' hoặc làm mất cân bằng sự kiện, nền tảng có quyền loại người phát trực tiếp và thu hồi điểm sự kiện của họ (bao gồm nhưng không giới hạn ở việc úp mặt, phát trực tiếp chất lượng thấp, màn hình đen, AFK, phát trực tiếp chơi game, xem TV, v.v.).",
    lang54: "9. Nền tảng có quyền giải thích cuối cùng về sự kiện này.",
    lang55: "2. Thời lượng sự kiện được tính mỗi hai phút.",
    lang57: "Thắng",
    lang58: "Rút thăm",
    lang59: "Thua",
    lang60: "Giai đoạn Thưởng 1",
    lang61: "Giai đoạn Thưởng 2",
    lang62: "Giai đoạn thưởng 3",
    lang63: "Giai đoạn Thưởng 4",
    lang64: "Cấp độ phần thưởng",
    lang65: "Yêu cầu điểm",
    lang66: "Điểm đạt được",
    lang67: "Có thể nhận",
    lang68: "Đổi điểm thành công",
    lang69: "Giống",
    lang70: "khen",
    lang71: "Bạn đã nhận điểm của ngày hôm nay rồi",
  } /* 合作联系 */,

  cooperate: {
    lang1: "Tin nhắn của bạn đã được gửi thành công!",
    lang2: "Biệt danh của bạn",
    lang3: "Phương tiện liên hệ:",
    lang4: "Thông tin liên hệ:",
    lang5:
      "Cảm ơn bạn rất nhiều vì tin nhắn hợp tác và những góp ý cho sự phát triển của FIREFLY. Nhân viên của chúng tôi sẽ liên hệ với bạn. Vui lòng chú ý đến thông tin liên hệ mà bạn đã để lại.",
    lang6: "Giới thiệu hợp tác Host",
    lang7: "Xem trang chủ sứ giả",
    lang8: "Trở về trang chủ",
    lang9:
      "Host FIREFLY, người mời người dùng hoặc thành viên bang hội trở thành sứ giả có thể thiết lập mối quan hệ thư từ với những người họ mời và nhận phần thưởng dài hạn. Những sứ giả xuất sắc cũng sẽ tự động nhận được các đặc quyền trong cộng đồng.",
    lang10: "Vui lòng để lại thông tin liên hệ của bạn",
    lang11: "Vui lòng để lại thông tin liên hệ thay thế của bạn (tùy chọn)",
    lang12: "Tin nhắn của bạn gửi đến FIREFLY",
    lang13: "Vui lòng nhập tin nhắn của bạn gửi đến FIREFLY",
    lang14: "Xác nhận gửi",
    lang15: "Chọn phương tiện liên hệ",
    lang16: "Wechat",
    lang17: "Hợp tác Host",
    lang18: "Host độc lập tự tham gia FIREFLY",
    lang19: "Hợp tác Sứ giả",
    lang20: "Tham gia FIREFLY với tư cách bang hội",
    lang21: "Hợp tác kinh doanh",
    lang22: "Quảng cáo và Truyền thông",
    lang23: "Ý kiến người chơi",
    lang24: "Kênh gửi ý kiến người chơi FIREFLY",
    lang25: "Liên hệ hợp tác",
    lang26: "Vui lòng nhập FIREFLY ID của bạn",
    lang27: "Vui lòng nhập Whatsapp ID của bạn",
    lang28: "Vui lòng nhập Telegram ID của bạn",
    lang29: "Vui lòng nhập Facebook ID của bạn",
    lang30: "Vui lòng nhập Email của bạn",
    lang31: "Vui lòng nhập Wechat của bạn",
    lang32: "Vui lòng nhập Line của bạn",
    lang33: "Vui lòng thử lại sau",
    lang34: "Vui lòng nhập biệt danh của bạn",
    lang35: "Vui lòng nhập thông tin liên hệ của bạn",
    lang36: "Vui lòng nhập tin nhắn của bạn",
  },
  premiumNumberCommitLetter: {
    lang1: "Thư cam kết kích hoạt số đẹp",
    lang2: "Kính gửi ",
    lang3: "ID gốc: ",
    lang4: "Số đẹp bạn đã đăng ký ",
    lang5:
      "sắp được kích hoạt cho bạn. Để đảm bảo trật tự và an toàn tài khoản, vui lòng đọc và đồng ý các điều khoản sau:",
    lang6:
      "Số đẹp bạn nhận được là tài nguyên khan hiếm và không thể tái tạo trong cộng đồng FIREFLY. Việc chuyển nhượng loại tài khoản này có thể ảnh hưởng tiêu cực đến sự ổn định và cấu trúc cộng đồng.",
    lang7: "[Điều khoản cam kết]",
    lang8:
      "1. Tôi cam kết số đẹp này chỉ dùng cho bản thân và không cung cấp cho bên thứ ba dưới bất kỳ hình thức nào (bán, cho thuê, tặng, chuyển nhượng...).",
    lang9:
      "2. Tôi hiểu rằng nếu vi phạm, nền tảng có quyền thu hồi số đẹp này và có thể áp dụng hạn chế đối với tài khoản gốc như khóa hoặc hạ quyền.",
    lang10:
      "3. Tôi cam kết tuân thủ thỏa thuận người dùng và pháp luật liên quan, không sử dụng số đẹp cho hành vi vi phạm.",
    lang11:
      "Thư cam kết có hiệu lực ràng buộc ngay sau khi ký. Cảm ơn sự thông cảm và hợp tác của bạn.",
    lang12: "Tôi không đồng ý",
    lang13: "Tôi đồng ý",
    lang14: "Người dùng đã đồng ý",
    lang15: "Thời gian đồng ý: ",
    lang16: "Đã gửi yêu cầu di chuyển",
    lang17:
      "Thời gian di chuyển cụ thể sẽ do bộ phận CSKH thông báo. Cảm ơn sự ủng hộ của bạn.",
    lang18: "Tôi đã biết",
    lang19: "Bạn đã gửi yêu cầu thành công. Cảm ơn sự ủng hộ của bạn.",
    lang20: "Làm mới",
    lang21: "Tư vấn CSKH",
    lang22: "Đóng trang",
    lang23: "Thêm",
  },
  vipUpPublicNotice: {
    lang1:
      "Để mang đến trải nghiệm tương tác cao cấp và riêng tư hơn, chúng tôi sẽ chính thức ra mắt hệ thống cấp VIP mới vào ",
    lang2: "2026/8/4",
    lang3: "Chính thức ra mắt cấp độ VIP mới",
    lang4:
      "Bản cập nhật này điều chỉnh điểm tài phú cần thiết cho một số cấp VIP và bổ sung nhiều quyền lợi phong phú. Thay đổi chính như sau:",
    lang5: "Sau khi hệ thống mới hoạt động, cấp tài phú cũ sẽ ",
    lang6: "được kế thừa tự động dựa trên điểm tài phú",
    lang7: " sang cấp VIP tương ứng trong hệ thống mới.",
    lang8:
      "Ví dụ: trước đây là VIP43 với 3.254.120 điểm, sẽ được kế thừa thành VIP45. Điểm không đổi và nhận quyền lợi VIP tương ứng.",
    lang9: "Loại quyền lợi",
    lang10: "Quyền lợi cụ thể",
    lang11: "Cấp mở khóa",
    lang12: "Ẩn danh",
    lang13: "Tàng hình",
    lang14: "Miễn quản trị",
    lang15: "Chống đá/ẩn",
    lang16: "Xe cá nhân",
    lang17: "Xe độc quyền tùy chỉnh",
    lang18: "Hệ thống số đẹp",
    lang19: "Số đẹp 6/5/4 chữ số",
    lang20: "Màu đạn chữ",
    lang21: "Tùy chỉnh 3/5 màu",
    lang22: "Dịch vụ độc quyền",
    lang23: "Kênh CSKH độc quyền",
    lang24: "Ưu đãi nạp",
    lang25: "Kênh nạp độc quyền",
    lang26: "Trang cá nhân đẹp",
    lang27: "Nền thẻ cá nhân tĩnh/động",
    lang28: "Quà tặng tùy chỉnh",
    lang29: "Quà trung cấp (5s) / cao cấp (10s)",
    lang30: "Thông báo toàn site",
    lang31: "Thông báo online toàn site",
    lang32: "Trong quá trình phát triển nền tảng, chúng tôi sẽ ",
    lang33: "liên tục hoàn thiện quyền lợi VIP và trải nghiệm dịch vụ",
    lang34:
      ". Nếu có thay đổi về quyền lợi, chúng tôi sẽ thông báo kịp thời. Vui lòng theo dõi.",
    lang35: "Firefly giữ quyền giải thích cuối cùng",
  },
  // Ludo
  ludo: {
    clubPkRoom: "Phòng PK của {club}",
    lang1: "Mở phòng",
    lang2: "Vào nhanh",
    lang3: "Phí vào",
    lang4: "Đang chờ",
    lang5: "Hiện không có phòng Ludo PK",
    lang6: "Chế độ chơi",
    lang7: "CLB mặc định",
    lang8: "Cổ điển",
    lang9: "Không giới hạn",
    lang10: "Thành tích",
    lang11: "Xếp hạng",
    lang12: "Sương vào cửa",
    lang13: "Thông tin cách chơi",
    lang16: "Thanh toán sương vào cửa để tham gia Ludo PK",
    lang17: "Số người chơi",
    lang18: "Phần thưởng chiến thắng",
    lang19: "Danh vọng",
    lang20: "Đạo cụ của tôi",
    lang21: "Quân cờ",
    lang22: "Bàn cờ",
    lang23: "Chọn đạo cụ quân cờ bạn muốn dùng trong trò chơi LUDO.",
    lang24:
      "Chọn đạo cụ bàn cờ cho phòng PK câu lạc bộ của bạn trong trò chơi LUDO.",
    lang25: "Huy hiệu thời gian",
    lang26: "Đã chọn",
    lang27: "Mặc định",
    lang28: "Vui lòng chọn đạo cụ",
    lang31: "Sử dụng",
    lang32: "Nhấn để chọn đạo cụ muốn dùng",
    lang33: "Nhấn để dùng, ván LUDO tiếp theo sẽ dùng đạo cụ bàn cờ này",
    lang34: "Nhấn để dùng, ván LUDO tiếp theo sẽ dùng đạo cụ quân cờ này",
    lang35: "Đang sử dụng",
    lang36: "Vui lòng chọn đạo cụ muốn sử dụng",
    lang37: "Sử dụng thành công, có hiệu lực ở ván LUDO tiếp theo",
    lang38: "ngày",
    lang39: "giờ",
    lang40: "phút",
    lang42: "Hiện chưa có bản ghi LUDO PK",
    lang43: "Chi tiết trò chơi",
    lang45: "Phí phòng",
    lang46: "Thời gian",
    lang47: "Sương",
    lang49: "Ngày",
    lang50: "Tổng",
    lang51: "Ảnh người chơi",
    lang52: "Xếp hạng",
    lang53: "Hạng 1",
    lang54: "Hạng 2",
    lang55: "Hạng 3",
    lang56: "Hạng 4",
    lang57: "Đang tải...",
    lang58: "CSKH",
    lang59: "Thắng",
    lang60: "Thua",
    lang61: "Hòa",
    lang62: "Giải thích cách chơi",
    lang63: "Luật chơi",
    lang64: "Số người chơi",
    lang66: "Phán định thắng thua",
    lang68: "Danh vọng câu lạc bộ",
    lang69: "Tham gia trò chơi",
    lang70: "Tham gia giữa chừng",
    lang72: "Cất cánh",
    lang73: "Ba lần sáu liên tiếp",
    lang74: "Di chuyển",
    lang75: "Chồng quân",
    lang76: "Ăn quân",
    lang77: "Vùng an toàn",
    lang78: "2-4 người",
    lang79:
      "Cổ điển: Quân cờ của người chơi phải bắt đầu từ điểm xuất phát, đi một vòng quanh bàn cờ rồi đến đích. Khi tất cả quân cờ đến đích thì trò chơi hoàn thành. Người hoàn thành càng nhanh thứ hạng càng cao.",
    lang80:
      "Theo chế độ chơi, người hoàn thành trò chơi trước sẽ có thứ hạng cao hơn. Ví dụ người đầu tiên hoàn thành sẽ là hạng nhất của ván này, và tiếp tục như vậy.",
    lang81:
      "Sau khi trò chơi kết thúc, bạn có thể nhận phần thưởng sương và danh vọng theo thứ hạng của mình.",
    lang82:
      "Nếu bạn thắng trò chơi trong phòng câu lạc bộ đã tham gia, danh vọng của bạn trong câu lạc bộ đó sẽ tăng theo thứ hạng trò chơi.",
    lang83:
      "Thanh toán lượng sương vào cửa do chủ phòng đặt để tham gia trò chơi.",
    lang84:
      "Trong trò chơi đã bắt đầu, người chơi có thể trả sương vào cửa để tham gia Ludo PK giữa chừng.",
    lang85:
      "Phải tung xúc xắc ra số sáu thì quân cờ mới có thể cất cánh từ căn cứ đến ô xuất phát.",
    lang86:
      "Nếu trong cùng một lượt tung được 3 lần số sáu, sẽ kích hoạt ba sáu liên tiếp và người chơi bị bỏ qua lượt này.",
    lang87:
      "Người chơi tung xúc xắc để nhận số điểm và di chuyển quân cờ tiến số bước tương ứng.",
    lang88:
      "Quân cờ của cùng một người chơi đứng tại cùng một vị trí sẽ tạo thành chồng quân. Khi bị ăn, toàn bộ chồng quân sẽ bị đá về căn cứ.",
    lang89:
      "Nếu quân cờ dừng ở ô có quân của người chơi khác, tất cả quân của người chơi khác sẽ bị đá về căn cứ và cần cất cánh lại mới có thể tiếp tục di chuyển.",
    lang90:
      "Quân cờ rơi vào điểm xuất phát hoặc ô có khiên trên bàn cờ sẽ không bị ăn. Quân cờ của các người chơi khác nhau có thể cùng đứng ở những ô này.",
    lang91:
      "Mỗi ván chơi sẽ thu một lượng sương cố định làm phí phòng. Mức phí phòng được xác định theo lượng sương vào cửa và không liên quan đến số người chơi. Khi quyết toán phần thưởng sương sau khi kết thúc trò chơi, hệ thống sẽ tự động khấu trừ phí phòng trước rồi mới phát phần thưởng sương cho người thắng.",
    lang92: "Tham gia trò chơi",
    lang93: "Phí phòng trò chơi",
    lang94: "Thắng",
    lang95: "Người chơi",
    lang96: "Sương quyết toán",
    lang97: "Phí trận",
    lang98: "Tiền cược gốc",
    lang99: "/trận",
    lang100: "Thành tích của tôi",
    lang101: "Người chơi tham gia",
    lang102: "Lịch sử",
  },
  teenPatti: {
    recordTitle: "Lịch sử",
    rankingTitle: "Bảng xếp hạng",
    confirm: "Xác nhận",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "Cài đặt trò chơi",
    maxBet: "Cược sương tối đa",
    maxPot: "Tổng cược tối đa",
    buyInDew: "Sương mang vào",
    mockJoinTip: "Chế độ thử: đã chọn sương gốc {ante}. Chưa kết nối chức năng tham gia.",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "Phòng PK của {club}",
    // 三张牌规则页文案：暂沿用此前的英文回退内容，待补充本语言翻译。
    title: "How to play",
    hands: "Hands",
    play: "Rules",
    order: "Hands ranked from highest to lowest",
    players: "Players: 2–5",
    mode: "Game mode:",
    intro: "Teen Patti is a strategy game in which players compare three-card hands. Read your hand and your opponents’ Dew wagers, then call, raise or compare hands to compete for the Dew in the pot. Suits do not determine hand strength.",
    flow: "Game flow",
    ante: "Sương gốc",
    anteText: "At the start of each game, the fixed base Dew set by the host is automatically deducted from every player and added to the pot.",
    deal: "Dealing",
    dealText: "Each player receives 3 face-down cards. Only the player can view their own cards after choosing to look at them.",
    turn: "Turns",
    turnText: "Players act in order until only one player remains, the pot limit is reached or the round limit is reached.",
    actions: "Player actions",
    blind: "Blind",
    blindText: "Wager Dew without looking at your cards. Calls and raises cost 1× the current Dew wager.",
    seen: "Seen",
    seenText: "Continue playing after viewing your cards. Calls and raises cost twice the blind player’s Dew wager.",
    compare: "Compare hands",
    condition: "Availability",
    conditionText: "Players can request a comparison from the second round onwards.",
    cost: "Cost",
    costText: "Requesting a comparison costs twice the current single Dew wager.",
    compareResult: "Result",
    compareResultText: "The requester can privately compare with any active player. If both hands have exactly the same type and ranks, the requester loses. The losing player is eliminated from the game.",
    fold: "Fold",
    foldText: "Leave the current game. Dew already contributed to the pot is not refunded.",
    allIn: "All in",
    allInText: "If your balance cannot cover the minimum call, you can put your entire remaining balance into the pot. You cannot take any more actions that game, but your hand is kept until the final showdown.",
    settlement: "Settlement",
    end: "Round limit",
    endText: "Each game has a maximum number of rounds to keep play moving. Refer to the limit displayed in the room.",
    showdown: "Showdown",
    showdownText: "When the round limit is reached, or only two players remain and one requests a showdown, the system reveals the remaining hands for a final comparison.",
    reward: "Dew reward",
    rewardText: "The winner receives the entire pot after the platform’s fixed-percentage service fee or commission has been deducted.",
    hand1: "Three of a kind",
    desc1: "Three cards of the same rank, such as AAA or 222",
    hand2: "Straight flush",
    desc2: "Three consecutive cards of the same suit, such as 4–5–6 of spades",
    hand3: "Flush",
    desc3: "Three cards of the same suit that are not consecutive",
    hand4: "Straight",
    desc4: "Three consecutive cards of mixed suits, such as 5♥, 6♦, 7♠",
    hand5: "Pair",
    desc5: "Two cards of the same rank and a third card, such as 223",
    hand6: "High card",
    desc6: "A hand that does not form any of the combinations above",
    hand7: "235",
    desc7: "A mixed-suit 2, 3 and 5 beats three of a kind only when a three-of-a-kind hand is present at the table. Otherwise, 235 is treated as a high-card hand.",
    rankOrder: "Within a hand type, A is highest and 2 is lowest. AAA is the highest three of a kind; 222 is the lowest. For straights and straight flushes, A–K–Q is highest and 3–2–A is lowest.",
    sameHand: "For flushes and high-card hands, compare the highest card first, then the second and third cards if tied. Suits have no ranking.",
    samePair: "For pairs, compare the pair first, then the remaining card if tied.",
    lang1: "Mở phòng",
    lang2: "Vào nhanh",
    lang3: "Phí vào",
    lang4: "Đang chờ",
    lang5: "Hiện không có phòng Teen Patti PK",
    lang6: "Chế độ chơi",
    lang7: "CLB mặc định",
    lang8: "Cổ điển",
    lang9: "Không giới hạn",
    lang10: "Thành tích",
    lang11: "Xếp hạng",
    lang12: "Sương vào cửa",
    lang13: "Thông tin cách chơi",
    lang16: "Thanh toán sương vào cửa để tham gia Ludo PK",
    lang17: "Số người chơi",
    lang18: "Phần thưởng chiến thắng",
    lang19: "Danh vọng",
    lang20: "Đạo cụ của tôi",
    lang21: "Quân cờ",
    lang22: "Bàn cờ",
    lang23: "Chọn đạo cụ quân cờ bạn muốn dùng trong trò chơi LUDO.",
    lang24:
      "Chọn đạo cụ bàn cờ cho phòng PK câu lạc bộ của bạn trong trò chơi LUDO.",
    lang25: "Huy hiệu thời gian",
    lang26: "Đã chọn",
    lang27: "Mặc định",
    lang28: "Vui lòng chọn đạo cụ",
    lang31: "Sử dụng",
    lang32: "Nhấn để chọn đạo cụ muốn dùng",
    lang33: "Nhấn để dùng, ván LUDO tiếp theo sẽ dùng đạo cụ bàn cờ này",
    lang34: "Nhấn để dùng, ván LUDO tiếp theo sẽ dùng đạo cụ quân cờ này",
    lang35: "Đang sử dụng",
    lang36: "Vui lòng chọn đạo cụ muốn sử dụng",
    lang37: "Sử dụng thành công, có hiệu lực ở ván LUDO tiếp theo",
    lang38: "ngày",
    lang39: "giờ",
    lang40: "phút",
    lang42: "Hiện chưa có bản ghi Teenpatti PK",
    lang43: "Chi tiết trò chơi",
    lang45: "Phí phòng",
    lang46: "Thời gian",
    lang47: "Sương",
    lang49: "Ngày",
    lang50: "Tổng",
    lang51: "Ảnh người chơi",
    lang52: "Xếp hạng",
    lang53: "Hạng 1",
    lang54: "Hạng 2",
    lang55: "Hạng 3",
    lang56: "Hạng 4",
    lang57: "Đang tải...",
    lang58: "CSKH",
    lang59: "Thắng",
    lang60: "Thua",
    lang61: "Hòa",
    lang62: "Giải thích cách chơi",
    lang63: "Luật chơi",
    lang64: "Số người chơi",
    lang66: "Phán định thắng thua",
    lang68: "Danh vọng câu lạc bộ",
    lang69: "Tham gia trò chơi",
    lang70: "Tham gia giữa chừng",
    lang72: "Cất cánh",
    lang73: "Ba lần sáu liên tiếp",
    lang74: "Di chuyển",
    lang75: "Chồng quân",
    lang76: "Ăn quân",
    lang77: "Vùng an toàn",
    lang78: "2-4 người",
    lang79:
      "Cổ điển: Quân cờ của người chơi phải bắt đầu từ điểm xuất phát, đi một vòng quanh bàn cờ rồi đến đích. Khi tất cả quân cờ đến đích thì trò chơi hoàn thành. Người hoàn thành càng nhanh thứ hạng càng cao.",
    lang80:
      "Theo chế độ chơi, người hoàn thành trò chơi trước sẽ có thứ hạng cao hơn. Ví dụ người đầu tiên hoàn thành sẽ là hạng nhất của ván này, và tiếp tục như vậy.",
    lang81:
      "Sau khi trò chơi kết thúc, bạn có thể nhận phần thưởng sương và danh vọng theo thứ hạng của mình.",
    lang82:
      "Nếu bạn thắng trò chơi trong phòng câu lạc bộ đã tham gia, danh vọng của bạn trong câu lạc bộ đó sẽ tăng theo thứ hạng trò chơi.",
    lang83:
      "Thanh toán lượng sương vào cửa do chủ phòng đặt để tham gia trò chơi.",
    lang84:
      "Trong trò chơi đã bắt đầu, người chơi có thể trả sương vào cửa để tham gia Ludo PK giữa chừng.",
    lang85:
      "Phải tung xúc xắc ra số sáu thì quân cờ mới có thể cất cánh từ căn cứ đến ô xuất phát.",
    lang86:
      "Nếu trong cùng một lượt tung được 3 lần số sáu, sẽ kích hoạt ba sáu liên tiếp và người chơi bị bỏ qua lượt này.",
    lang87:
      "Người chơi tung xúc xắc để nhận số điểm và di chuyển quân cờ tiến số bước tương ứng.",
    lang88:
      "Quân cờ của cùng một người chơi đứng tại cùng một vị trí sẽ tạo thành chồng quân. Khi bị ăn, toàn bộ chồng quân sẽ bị đá về căn cứ.",
    lang89:
      "Nếu quân cờ dừng ở ô có quân của người chơi khác, tất cả quân của người chơi khác sẽ bị đá về căn cứ và cần cất cánh lại mới có thể tiếp tục di chuyển.",
    lang90:
      "Quân cờ rơi vào điểm xuất phát hoặc ô có khiên trên bàn cờ sẽ không bị ăn. Quân cờ của các người chơi khác nhau có thể cùng đứng ở những ô này.",
    lang91:
      "Mỗi ván chơi sẽ thu một lượng sương cố định làm phí phòng. Mức phí phòng được xác định theo lượng sương vào cửa và không liên quan đến số người chơi. Khi quyết toán phần thưởng sương sau khi kết thúc trò chơi, hệ thống sẽ tự động khấu trừ phí phòng trước rồi mới phát phần thưởng sương cho người thắng.",
    lang92: "Tham gia trò chơi",
    lang93: "Phí phòng trò chơi",
    lang94: "Thắng",
    lang95: "Người chơi",
    lang96: "Sương quyết toán",
    lang97: "Phí trận",
    lang98: "Sương gốc",
  },
};
